import { render, staticRenderFns } from "./listaSetor.vue?vue&type=template&id=5dd4a5cd&scoped=true"
import script from "./listaSetor.vue?vue&type=script&lang=js"
export * from "./listaSetor.vue?vue&type=script&lang=js"
import style0 from "./listaSetor.vue?vue&type=style&index=0&id=5dd4a5cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd4a5cd",
  null
  
)

export default component.exports